import { render, staticRenderFns } from "./BillingAdjustmentsTab.vue?vue&type=template&id=6620b4fe&scoped=true"
import script from "./BillingAdjustmentsTab.vue?vue&type=script&lang=js"
export * from "./BillingAdjustmentsTab.vue?vue&type=script&lang=js"
import style0 from "./BillingAdjustmentsTab.vue?vue&type=style&index=0&id=6620b4fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6620b4fe",
  null
  
)

export default component.exports